import { render, staticRenderFns } from "./DependentsList.vue?vue&type=template&id=0223f376&"
import script from "./DependentsList.vue?vue&type=script&lang=js&"
export * from "./DependentsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports